// extracted by mini-css-extract-plugin
export default {"action_button":"social-ugc-actions-SocialActionButton__action_button--3fJPk","invert":"social-ugc-actions-SocialActionButton__invert--N_kIO"};